import { withInstall } from '@park-ui/utils'
import CigSearch from './src/index.vue'

export const ElCigSearch = withInstall(CigSearch)

export default ElCigSearch
